import { render, staticRenderFns } from "./chuang.vue?vue&type=template&id=5f84620b&scoped=true&"
import script from "./chuang.vue?vue&type=script&lang=js&"
export * from "./chuang.vue?vue&type=script&lang=js&"
import style0 from "./chuang.vue?vue&type=style&index=0&id=5f84620b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f84620b",
  null
  
)

export default component.exports